var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { Animate } from "sb-resp-ui";
import Debounce from "debounce-decorator";
import { observer } from "mobx-react";
import { DeviceDetect } from "sb-resp-utils";
/* tslint:disable:cyclomatic-complexity */
/* shouldScroll method creates cyclomatic complexity of 7 */
/* TODO reduce cyclomatic complexity */
let Carousel = class Carousel extends React.Component {
    constructor(props) {
        super(props);
        this.calcs = {
            step: 0,
            container: 0,
            wrapper: 0
        };
        this.anims = { left: this.props.translate || 0 };
        this.state = {
            scrollable: {
                left: false,
                right: false
            },
            animation: {
                x: 0,
                duration: 0.6,
                ease: "back.out(0.7)"
            },
            deviceDetect: DeviceDetect.getInstance()
        };
        this.rtl = document.dir === "rtl" ? true : false;
    }
    /* istanbul ignore next */
    scrollLeft() {
        if (this.state.scrollable.left) {
            const l = this.anims.left + this.calcs.step;
            this.anims.left = l > 0 ? 0 : l;
            const o = Object.assign(Object.assign({}, this.state.animation), { x: (this.rtl ? -1 : 1) * this.anims.left });
            this.setState({ animation: o });
        }
    }
    /* istanbul ignore next */
    scrollRight() {
        if (this.state.scrollable.right) {
            const t = this.anims.left - this.calcs.step;
            const d = this.calcs.container - this.calcs.wrapper;
            this.anims.left = Math.abs(t) > d ? d * -1 : t;
            const o = Object.assign(Object.assign({}, this.state.animation), { x: (this.rtl ? -1 : 1) * this.anims.left });
            this.setState({ animation: o });
        }
    }
    setupCalcs() {
        if (this.wrapper && this.container) {
            this.calcs.step = (this.props.step && this.props.step < this.wrapper.offsetWidth) ? this.props.step : this.wrapper.offsetWidth;
            this.calcs.wrapper = this.wrapper.offsetWidth;
            this.calcs.container = this.container.offsetWidth;
        }
    }
    shouldScroll() {
        if (this.wrapper && this.container) {
            const sLeft = this.anims.left < 0 ? true : false;
            const sRight = this.calcs.container - this.calcs.wrapper + this.anims.left > 0 ? true : false;
            if (this.state.scrollable.left !== sLeft ||
                this.state.scrollable.right !== sRight) {
                this.setState({
                    scrollable: {
                        left: sLeft,
                        right: sRight
                    }
                });
            }
        }
    }
    /* istanbul ignore next */
    scrollWheel(e) {
        if (e.deltaY < 0) {
            this.scrollLeft();
        }
        else {
            this.scrollRight();
        }
    }
    /* istanbul ignore next */
    resetScroll() {
        this.anims.left = 0;
        this.setState({
            animation: Object.assign(Object.assign({}, this.state.animation), { x: 0 })
        });
    }
    /* istanbul ignore next */
    handleEvent(e) {
        if (e.type === "resize") {
            if (this.state.deviceDetect.isDesktop) {
                this.resetScroll();
                this.setupCalcs();
                this.shouldScroll();
            }
            else {
                if (this.wrapper) {
                    this.wrapper.scrollLeft = this.props.mobileScroll.value;
                }
            }
        }
    }
    /* istanbul ignore next */
    onClickArrowsHandler(direction) {
        this["scroll" + direction]();
        this.shouldScroll();
    }
    updateScrollPosition() {
        this.shouldScroll();
        const o = Object.assign(Object.assign({}, this.state.animation), { x: this.anims.left });
        this.setState({ animation: o });
    }
    componentDidMount() {
        if (this.state.deviceDetect.isDesktop) {
            this.setupCalcs();
            this.shouldScroll();
            window.addEventListener("resize", this);
            this.container && this.container.addEventListener("wheel", this.scrollWheel.bind(this));
        }
        this.updateScrollPosition();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.deviceDetect.isDesktop) {
            this.setupCalcs();
            this.shouldScroll();
            if (this.props.translate !== prevProps.translate) {
                this.anims.left = this.props.translate || 0;
                this.updateScrollPosition();
            }
        }
        else {
            if (this.wrapper) {
                if (this.props.mobileScroll.isResize || this.props.mobileScroll.isInitiate) {
                    this.wrapper.scrollLeft = this.props.mobileScroll.value;
                    this.props.mobileScroll.isInitiate = false;
                    this.props.mobileScroll.isResize = false;
                }
            }
        }
    }
    render() {
        let cls = "rj-carousel";
        cls += this.state.scrollable.left ? " rj-carousel--sLeft" : "";
        cls += this.state.scrollable.right ? " rj-carousel--sRight" : "";
        this.props.mobileScroll.isInitiate; //hack to trigger rerender
        this.props.mobileScroll.isResize; //hack to trigger rerender
        return (React.createElement("div", { className: cls, ref: n => this.wrapper = n, "data-uat": "scarousel" },
            (this.state.deviceDetect.isDesktop) &&
                (React.createElement("div", { className: "rj-carousel-arrow rj-carousel-arrow-left", onClick: this.onClickArrowsHandler.bind(this, "Left"), "data-uat": "scarousel-btn-prev" },
                    React.createElement("div", { className: "rj-carousel-arrow--inner" }))),
            (this.state.deviceDetect.isDesktop) &&
                (React.createElement("div", { className: "rj-carousel-arrow rj-carousel-arrow-right", onClick: this.onClickArrowsHandler.bind(this, "Right"), "data-uat": "scarousel-btn-next" },
                    React.createElement("div", { className: "rj-carousel-arrow--inner" }))),
            React.createElement(Animate, Object.assign({}, this.state),
                React.createElement("div", { className: "rj-carousel-container", ref: n => this.container = n }, this.props.children))));
    }
};
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Carousel.prototype, "scrollWheel", null);
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Carousel.prototype, "resetScroll", null);
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Event]),
    __metadata("design:returntype", void 0)
], Carousel.prototype, "handleEvent", null);
__decorate([
    Debounce(50),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], Carousel.prototype, "onClickArrowsHandler", null);
Carousel = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], Carousel);
export { Carousel };
//# sourceMappingURL=Carousel.js.map